import { Component, computed, OnInit, signal, Signal } from '@angular/core';

import { ProfileInfoBoxComponent } from '../../profile-info-box.component';
import { ProfileInfoBoxBaseComponent } from '../profile-info-box-base.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormRowComponent } from '../../../../form/form-row/form-row.component';
import { FormFieldComponent } from '../../../../form/form-field/form-field.component';
import { IMDDropDownOption, MDDropDownComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-profile-education-info-box',
	standalone: true,
	imports: [FormsModule, ReactiveFormsModule, ProfileInfoBoxComponent, FormRowComponent, FormFieldComponent, MDDropDownComponent],
	templateUrl: './profile-education-info-box.component.html',
	styleUrl: './profile-education-info-box.component.scss'
})
export class ProfileEducationInfoBoxComponent extends ProfileInfoBoxBaseComponent implements OnInit {
	public educationLevelOptions: Signal<IMDDropDownOption[]> = computed(() => {
		return this._profileSupportDateStateService.educationLevels().map((educationLevel) => {
			return {
				value: educationLevel.educationLevelID,
				label: educationLevel.educationLevelName
			};
		});
	});

	public graduationYearOptions: Signal<IMDDropDownOption[]> = signal(this.createGraduationYearOptions());
	ngOnInit(): void {
		const form: FormGroup = this.form();

		form.addControl('educationLevel', new FormControl({ value: this.profile().educationLevelID, disabled: true }));
		form.addControl('graduationYear', new FormControl({ value: this.profile().highSchoolGraduationYear, disabled: true }));
		form.addControl('currentSchool', new FormControl({ value: this.profile().currentSchool, disabled: true }));
	}

	private createGraduationYearOptions(): IMDDropDownOption[] {
		const maxGraduationYear = new Date().getFullYear() + 15;
		const years = [];

		for (let i = 0; i < 100; i++) {
			years.push({ value: maxGraduationYear - i, label: (maxGraduationYear - i).toString() });
		}

		return years;
	}
}
